import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'independent-study-card',
    components: {
    },
})


export default class IndependentStudyCard extends Vue {
    @Prop({ default: '' })
    public item: any;

    public isCreateProgram: boolean = false;

    public onClickProgramCard(item: any) {
        this.$emit('onClickProgramCard', item);
    }
}
